import React from 'react';
import styles from '../event.scss';

class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className={`${styles.popup} ${this.props.themeV3 ? styles.themeV3 : ''}`}>
                <div
                    className={`${styles.popup_inner}`}
                    style={this.props.topPoint ? { top: this.props.topPoint.toString(), transform: `translateX(-50%) translateY(-50%)` } : {}}
                >
                    <div className={styles.gradientBar} />
                    <div className={`${styles.popupContent}`}>
                        {this.props.title && (
                            <h5>{this.props.title}</h5>
                        )}
                        <p>{this.props.message}</p>
                    </div>
                    <div className={`text-right ${styles.popupFooter}`}>
                        <button
                            type="button"
                            className={`btn btn-default btn-sm text-uppercase`}
                            onClick={this.props.closePopup}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className={`btn ${this.props.type === 'reset_event_draws_event' ? 'btn-danger' : 'btn-primary'} btn-sm text-uppercase`}
                            onClick={() => {
                                this.props.confirmPopup();
                            }}
                        >
                            {this.props.type === 'reset_event_draws_event' ? 'Reset' : 'Continue'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Popup;
